import * as React from "react"
import { InjectedIntlProps, injectIntl, FormattedNumber } from "react-intl"
import { bodyW } from "../pptx-configuration/constants"
import * as CommonUtils from "../utils"
import * as Conf from "../../configuration"
import * as LoanDomain from "../../../../domain/sfp/loan-domain"
import * as Model from "../../../../model"
import * as moment from "moment"

class DebtTable extends React.Component<Props & InjectedIntlProps> {
	private readonly labelCellWidth: number
	private readonly numberCellWidth: number
	private readonly valueCellWidth: number

	constructor(props: Props & InjectedIntlProps) {
		super(props)

		this.labelCellWidth = CommonUtils.toInches(4.1)
		this.numberCellWidth = CommonUtils.toInches(2)
		this.valueCellWidth = (bodyW - this.numberCellWidth - this.labelCellWidth)
		/ props.years.length
	}
	 handlingYear(d){
		let decom={
			interests: [],
			paymentAmounts: [],
			paymentDates: [],
			periodicRates: [],
			reimboursedCapitals: [],
			remainingCapitals: []
		} 
		d.decomposition.paymentDates.map((date, i) => {
		  let payDate
		  if(d.decomposition.remainingCapitals[i] > 0){
		  decom.interests.push(d.decomposition.interests[i])
		  decom.paymentAmounts.push(d.decomposition.paymentAmounts[i])
		  decom.paymentDates.push(date)
		  decom.periodicRates.push(d.decomposition.periodicRates[i])
		  decom.reimboursedCapitals.push(d.decomposition.reimboursedCapitals[i])
		  decom.remainingCapitals.push(d.decomposition.remainingCapitals[i])
	}
})
return decom
	}

	render() {
		const currency = this.props.currency
		const decomposition = this.props.decomposition
		const childDecomposedLoans = this.props.childDecomposedLoans
		const id = this.props.id
		const locale = this.props.locale
		const realDecomposedLoans: Model.LoanWithDecomposition[] = []
		const roundness = this.props.roundness
		const simulatedDecomposedLoans: Model.LoanWithDecomposition[] = []
		const tableConf = this.props.tableConfiguration
		const years = this.props.years
		const checked = this.props.checked
		let decompositions = []
		let calculation = []
		let decompositionsTotal = []



		childDecomposedLoans[0].forEach(rr=>{
				let decompos =[]
				if(this.props.checked == "globel"){
					rr.map(d =>{
						if(d && d.loan){
                          let decom = this.handlingYear(d)
							decompos.push(decom)
						}
					})
				}

				if(this.props.checked == "simulées"){
					rr.map(d =>{
						if(d && d.loan){
						if(d.loan.simulate){
							let decom = this.handlingYear(d)
							decompos.push(decom)
						}
					}
					})
				}

				if(this.props.checked == "reelles" ){
					rr.map(d =>{
						if(d && d.loan){
						if(!d.loan.simulate){
							let decom = this.handlingYear(d)
							decompos.push(decom)
						}
					}
					})
				}
				decompositions.push(decompos)
		})

		decompositions.map((rs,i)=>{
			let data =[]
            data.push(childDecomposedLoans[1][i])
			years.map((year, yearIndex) => {
			let value = 0
			if(rs.length > 0){
				if (Decomposition.Annuity === decomposition){
					value = LoanDomain.getTotalAnnuity(rs, year)
				}

				if (Decomposition.CapitalReimbursement === decomposition){
					value = LoanDomain
					.getTotalYearReimbursedCapital(rs, year)
				}

				if (Decomposition.InterestReimbursement === decomposition){
					value = LoanDomain
					.getTotalYearInterest(rs, year)
				}

				if (Decomposition.RemainingCapital === decomposition){
					value = LoanDomain
					.getTotalYearRemainingCapital(rs, year)
				}
	
			}else{
				value= 0
			}

			data.push(CommonUtils.formatCurrency(locale, currency, value || 0, roundness))
		})

		calculation.push(data)
			
		if(checked == "globel"){
				if(rs.length){
				rs.map(d=>{
						decompositionsTotal.push(d)
				})}
	     }

		if(checked == "simulées"){	
				if(rs.length){
				rs.map(d=>{
					decompositionsTotal.push(d)
			})}
		}

		if(checked == "reelles" ){
				if(rs.length){
				rs.map(d=>{
					decompositionsTotal.push(d)
			})}
		}
	})


		return <table id={id}>
			<thead>
				<tr>
					<th data-pptx-width={this.labelCellWidth}
					style={{ ...tableConf.header }}>Objet</th>

					{years.map((year, yearIndex) =>
						<th data-pptx-width={this.valueCellWidth}
						key={yearIndex}
						style={{ ...tableConf.header }}>{year}</th>
					)}
				</tr>
			</thead>

			<tbody>	
			    {calculation.map((rr,I) =>{ 
		         return <tr key={I}>
				 {rr.map((res,i)=>{  
				return <td key={i} style={{ ...tableConf.common }}>
					{res}
				 </td>})}
		         </tr>})}
			</tbody>

			<tfoot>
				<tr>
					<td style={{ ...tableConf.total }}>Total</td>
					{years.map((year, yearIndex) => {

						let value = 0
						  
						if (Decomposition.Annuity === decomposition){
							value = LoanDomain.getTotalAnnuity(decompositionsTotal, year)
						}

						if (Decomposition.CapitalReimbursement === decomposition){
							value = LoanDomain
							.getTotalYearReimbursedCapital(decompositionsTotal, year)
						}

						if (Decomposition.InterestReimbursement === decomposition){
							value = LoanDomain
							.getTotalYearInterest(decompositionsTotal, year)
						}

						if (Decomposition.RemainingCapital === decomposition){
							value = LoanDomain
							.getTotalYearRemainingCapital(decompositionsTotal, year)
						}

						return <td key={yearIndex}
						style={{ ...tableConf.total, ...tableConf.numeric }}>
							{CommonUtils.formatCurrency(
								locale, currency, value || 0, roundness)}
						</td>
					})}
				</tr>
			</tfoot>
		</table>
	}
	}

export default injectIntl(DebtTable)

export enum Decomposition {
	Annuity,
	CapitalReimbursement,
	InterestReimbursement,
	RemainingCapital
}

export interface Props {
	currency: string
	childDecomposedLoans: any
	decomposition: Decomposition
	id: string
	locale: string
	roundness: Conf.RoundnessValue
	tableConfiguration: Conf.TableConfiguration
	years: number[]
	checked:string
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/debt-table.tsx